import { configureStore } from '@reduxjs/toolkit';
import { listenerMiddleware } from './middleware/middleware';
import { api } from './services/api';
import { dbApi } from './services/db-api';
import backgroundJobState from './slices/background-job-slice';
import dynamicPage from './slices/dynamic-page-slice';
import formBuilder from './slices/form-builder-slice';
import globalHierarchyFilters from './slices/global-hierarchies';
import layout from './slices/layout';
import offlineSync from './slices/offline-sync-slice';
import schema from './slices/schema';
import { setStoreAccessors } from './store-accessors';

const store = configureStore({
  reducer: {
    [api.reducerPath]: api.reducer,
    [dbApi.reducerPath]: dbApi.reducer,
    layout,
    schema,
    dynamicPage,
    globalHierarchyFilters,
    backgroundJobState,
    formBuilder,
    offlineSync,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: { warnAfter: 40 } })
      .prepend(listenerMiddleware.middleware)
      .concat(api.middleware)
      .concat(dbApi.middleware),
});

// register store accessors after store is created
setStoreAccessors(store.dispatch);

export default store;

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
